export default __webpack_public_path__ + "static/media/meme_up_black.df90cbef.svg";